module.exports = __webpack_public_path__ + "img/text-icon.ed417946.svg";